import {
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormControl, NgForm } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { Observable, Subject, debounceTime, of, switchMap, tap } from 'rxjs';
import { SuccessClaimComponent } from 'src/app/features/claims/dialogs/success-claim/success-claim.component';
import { AccessId } from 'src/app/models/admin/accessId.model';
import { Admin } from 'src/app/models/admin/admin.model';
import { AccessLevel, Login } from 'src/app/models/login.model';
import { AdminService } from 'src/app/services/admin.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ResendWelcomeletterComponent } from '../resend-welcomeletter/resend-welcomeletter.component';

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.scss'],
})
export class AddUserComponent implements OnInit {
  loggedInUser = new Login('', '', '', '', '', '', 0, false, false, false, '', false);
  admin = new Admin('', '', '', '', 0, '', true, 0, '');
  accessId1: FormControl;
  successMessage: string = '';
  enumAccessLevel = AccessLevel;
  filteredAccessIds: Observable<any[]>;
  editable: boolean = true;
  emailhasAt: boolean = true;
  emailhasDot: boolean = true;
  disbaleAccessId: boolean = false;
  status: boolean = true;

  accessId = '';
  title: string = 'Add User';
  btnTitle: string = 'Save';

  accessIds: Observable<any[]>;
  accessIdsDistrictUser: AccessId[] = [];
  searchTerms = new Subject<string>();
  ClientName = '';
  flag: boolean = true;

  accessLevelOptions = [
    { label: 'Campus Official', value: 0 },
    { label: 'District Official', value: 1 },
    { label: 'Agent Official', value: 2 },
    { label: 'State Official', value: 3 },
    { label: 'Admin Official', value: 5 },
    { label: 'IT Official', value: 9 },
  ];
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<AddUserComponent>,
    private authService: AuthenticationService,
    private adminService: AdminService,
    private matDialog: MatDialog
  ) {
    this.accessId1 = new FormControl();

    if (data.type == 'Edit') {
      this.title = 'Edit User';
      this.btnTitle = 'Update';
      this.editable = false;

      this.admin.firstName = data.element.firstName;
      this.admin.lastName = data.element.lastName;
      this.admin.userID = data.element.userID;
      this.admin.email = data.element.email;
      this.admin.accessLevelID = data.element.accessLevelID;
      this.admin.accessLevel = data.element.accessLevel;
      this.admin.accessID = data.element.accessID;
      this.admin.status = data.element.status;
      this.admin.accessName = data.element.accessName;
    } else {
      this.title = 'Add User';
      this.btnTitle = 'Save';
      this.editable = true;
    }
  }

  ngOnInit(): void {
    this.authService.setLogin.subscribe((value) => {
      this.loggedInUser = value;

      if (this.loggedInUser.accessLevel == this.enumAccessLevel.DISTRICTUSER) {
        this.admin.accessLevelID = 0;
        this.getAccessIdForDistrictUser();
        this.setAccessLevelProperty();
      } else {
        this.setAccessLevelProperty();
        this.getAccessIds();
      }

      if (this.title.includes('Edit')) {
        if (
          this.admin.accessLevelID == this.enumAccessLevel.ADMINUSER ||
          this.admin.accessLevelID == this.enumAccessLevel.IT
        ) {
          this.accessId1.setValue({ iD1: -1, name1: '', iD2: 0, name2: '' });
          this.accessId1.disable();
          //this.editable = false;
        } else {
          this.accessId1.setValue({
            iD1: this.admin.accessID,
            name1: '',
            iD2: 0,
            name2: '',
          });
          this.accessId1.enable();
        }
        this.setAccessLevelProperty();
      }
    });
  }

  setAccessLevelProperty() {
    this.admin.accessLevel = this.accessLevelOptions.filter(a => a.value == this.admin.accessLevelID)[0].label;
  }

  changeAccessLevel(event: any) {
    this.admin.accessLevel = this.accessLevelOptions.filter(a => a.value == this.admin.accessLevelID)[0].label;
    this.accessId1.reset();
    if (
      this.admin.accessLevelID == this.enumAccessLevel.ADMINUSER ||
      this.admin.accessLevelID == this.enumAccessLevel.IT
    ) {
      this.admin.accessID = -1;
      this.accessId1.setValue({ iD1: -1, name1: '', iD2: 0, name2: '' });
      this.disbaleAccessId = true;
      this.accessId1.disable();
    } else {
      this.accessId1.enable();
    }
  }

  getAccessIdForDistrictUser() {
    this.accessIdsDistrictUser = [];
    this.adminService
      .getAccessIdForAdmin(this.loggedInUser.accessId)
      .subscribe({
        next: (result: any) => {
          this.accessIdsDistrictUser = result;
        },
        error: (err: any) => {
          console.log(err);
        },
        complete: () => {
          console.log('complete');
        },
      });
  }

  getAccessIds() {
    this.accessIds = this.accessId1.valueChanges.pipe(
      debounceTime(300),
      switchMap((value) => {
        if (this.admin.accessLevelID != this.enumAccessLevel.ADMINUSER) {
          if (value != null) {
            if (value.length >= 3) {
              return this.adminService.getAccessId(
                this.admin.accessLevelID,
                this.loggedInUser.accessId,
                value
              );
            }
          }
        }
        return of<any[]>([]);
      })
    );
  }

  searchAccessId(term: string): void {
    this.flag = true;
    this.searchTerms.next(term);
  }

  selectedAccessId(event: any) {
    let access = event.option.value;
    this.admin.accessID = access.iD1;
    this.admin.accessName = access.name1;
  }

  getOptionText(option: any) {
    if (option != null) return option.iD1;
  }

  saveUser(form: NgForm) {
    if (form.invalid) return;
    this.adminService.saveNewUser(this.admin).subscribe({
      next: (res: any) => {
        if (res) {
          if (res) {
            this.successMessage = res;
            const dialogRef = this.matDialog.open(SuccessClaimComponent, {
              data: this.successMessage
            });
            const msg = this.successMessage;
            dialogRef.afterClosed().subscribe(value=>{
              if(msg=='User Added Successfully'){
                this.resendLetter();
              }
            })
          }
          this.successMessage = '';
          console.log(this.admin);
          this.closeDialog(this.admin);
        }
        this.successMessage = '';
      },
      error: (err: any) => {
        console.log(err);
      },
      complete: () => {
        console.log('complete');
      },
    });
  }

  closeDialog(admin: any = null) {
    this.dialogRef.close(admin);
  }

  ResendWelcomeLetter() {
    this.matDialog.open(ResendWelcomeletterComponent, {
      data: this.admin,
    });
  }

  resendLetter() {
    this.adminService.resendWelcomeLetter(this.admin).subscribe({
      next: (res: any) => {
        var successMessage = "";
        if (res) {
          if (res) {
            successMessage = res;
            // this.matDialog.open(SuccessClaimComponent, {
            //   data: successMessage
            //   //disableClose: true
            // });
          }
          successMessage = '';
          this.closeDialog();
        }

        successMessage = "";
      },
      error: (err: any) => {
        console.log(err);
      },
      complete: () => {
        console.log('complete');
      }
    });
  }
}
